<div class="card">
    <p class="card-title"><i class="flaticon-users"></i> Usuários</p>

    <div class="search-head">
        <div class="search-head__input">
            <i class="fa fa-search"></i>
            <input type="text" class="form-control"
            placeholder="Buscar usuários..."
                [(ngModel)]="term">
        </div>

        <div class="search-head__buttons">
            <a *ngIf="hasPermitionToViewLoginHistory" routerLink="/login-history" class="btn btn-small btn-outline-secondary">
                <i class="fas fa-history"></i> Histórico de Login
            </a>
            <a *ngIf="isAdminUser || hasPermitionToAdd" href="javascript:;" class="btn btn-small btn-primary"
            (click)="addNewUser(template)" >
                <i class="fas fa-plus"></i> Novo Usuário
            </a>
        </div>
    </div>

    <div class="process_list">
        <div class="process-item process-item_head">
          <div class="process-item__row">
            <p>Email</p>
          </div>
          <div class="process-item__row">
            <p>Login</p>
          </div>
          <div class="process-item__row">
            <p>Nome</p>
          </div>
          <div class="process-item__row"></div>
        </div>

        <div class="process-item" *ngFor="let user of users | filter: term | paginate: { itemsPerPage: 10, currentPage: p }">
            <div class="process-item__row">
              <p>{{user.email}}</p>
            </div>
            <div class="process-item__row">
              <p>{{user.userName}}</p>
            </div>
            <div class="process-item__row">
              <p>{{user.name}}</p>
            </div>
            <div class="process-item__row">
                <button *ngIf="isAdminUser || hasPermitionToEdit" type="button"
                class="btn btn-outline-secondary btn-icon"
                (click)="selectUser(user, template)"><i class="fa fa-edit"></i></button>

            </div>
        </div>
    </div>

    <pagination-controls (pageChange)="p = $event"></pagination-controls>
</div>

<ng-template #template>
    <div *ngIf="showEdition" class="new-user">
        <div class="m-portlet m-portlet--mobile">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            <i class="flaticon-plus"></i> Editar usuário

                            <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span aria-hidden="true">&times;</span></button>
                        </h3>
                    </div>
                </div>
            </div>

            <div class="m-portlet__body">
                <form (ngSubmit)="onSubmit()" #userForm="ngForm" class="m-form">
                    <div *ngIf="!newUser; else loginNewUser" class="form-group m-form__group">
                        <label for="nome">Login</label>
                        <p>{{ model.userName }}</p>
                    </div>
                    <ng-template #loginNewUser>
                        <div class="form-group m-form__group">
                            <label for="nome">Login <small>*</small></label>
                            <input
                            type="text"
                            class="form-control"
                            id="login"
                            name="login"
                            [(ngModel)]="model.userName"
                            #login="ngModel"
                            required>
                            <div [hidden]="login.valid || login.pristine" class="alert alert-danger">Login é obrigatório</div>
                        </div>
                    </ng-template>
                    <div *ngIf="!newUser" class="form-group m-form__group">
                        <label for="nome">Ativo</label>
                        <p>{{ model.inactive ? "Não" : "Sim" }}</p>
                    </div>
                    <div class="form-group m-form__group">
                        <label for="nome">Nome <small>*</small></label>
                        <input
                        type="text"
                        class="form-control"
                        id="name"
                        name="name"
                        [(ngModel)]="model.name"
                        #name="ngModel"
                        required>
                        <div [hidden]="name.valid || name.pristine" class="alert alert-danger">Nome é obrigatório</div>
                    </div>
                    <div class="form-group m-form__group">
                        <label for="email">Email <small>*</small></label>
                        <input
                            type="email"
                            class="form-control"
                            id="email"
                            name="email"
                            [(ngModel)]="model.email"
                            #email="ngModel"
                            required>
                        <div [hidden]="email.valid || email.pristine" class="alert alert-danger">Email é obrigatório</div>
                    </div>
                    <div class="form-group m-form__group">
                        <label for="phone">Telefone</label>
                        <input
                            type="text"
                            class="form-control"
                            id="phone"
                            name="phone"
                            [(ngModel)]="phone"
                            mask="(00) 00000 0000">
                    </div>
                    <div class="form-group m-form__group">
                        <label for="roles">Papéis </label>
                        <ng-select
                            name="roles"
                            [items]="roles"
                            [hideSelected]="true"
                            bindValue="id"
                            bindLabel="name"
                            multiple="true"
                            placeholder="Inclua os papéis do usuário"
                            [(ngModel)]="selectedRoles"
                            [addTag]="addNewRole"
                            [loading]="loadingRoles"
                            [addTagText]="'Criar papel: '">
                        </ng-select>
                    </div>
                    <div class="form-group m-form__group">
                        <label for="units">Unidades </label>
                        <ng-select
                            name="units"
                            [items]="units"
                            [hideSelected]="true"
                            bindValue="id"
                            bindLabel="name"
                            multiple="true"
                            placeholder="Inclua as unidades do usuário"
                            [(ngModel)]="selectedUnits"
                            [addTag]="addNewUnit"
                            [loading]="loadingUnits"
                            [addTagText]="'Criar unidade: '">
                        </ng-select>
                    </div>

                    <div class="text-center">
                        <button type="button"
                            class="btn btn-secondary"
                            (click)="changePasswordRequest()">Alterar senha</button>
                        <button type="button"
                            class="btn btn-secondary"
                            (click)="delete()">Excluir</button>
                        <button type="button"
                            class="btn btn-secondary"
                            (click)="inactivate()">{{ model.inactive ? "Ativar" : "Inativar" }}</button>
                        <button type="button"
                            class="btn btn-secondary"
                            (click)="cancel()"
                            >Cancelar</button>
                        <button type="submit"
                            class="btn btn-primary"
                            [disabled]="!userForm.form.valid">Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-template>
